import { injectJS } from 'ui/lib/loadJs';
import CONFIG from 'ui/config';
import SnackBar from 'ui/services/snackbar';

export const handleMidTrans = async (shop, data, helpers) => {
  await injectJS('midtranstag', CONFIG.MIDTRANS.host, { 'data-client-key': data.keyId });
  window.snap.pay(data.tx_token, {
    onSuccess: () => {
      helpers.redirect(data.id, data.pgTid);
    },
    onPending: (err) => {
      SnackBar.showError(err);
    },
    onError: (err) => {
      SnackBar.showError(err);
    },
    onClose: (err) => {
      SnackBar.showError(err);
    }
  });
};
